export const calculateAgeDetailed = (dobString) => {
  if (!dobString) return { years: 0, months: 0, days: 0, text: "" };
  const today = new Date();
  const birthDate = new Date(dobString);
  if (isNaN(birthDate.getTime())) return { years: 0, months: 0, days: 0, text: "" };

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  let text = "";
  if (years > 0) {
    text = `${years} ${years === 1 ? 'Year' : 'Years'}`;
  } else if (months > 0) {
    text = `${months} ${months === 1 ? 'Month' : 'Months'}`;
  } else {
    text = `${days} ${days === 1 ? 'Day' : 'Days'}`;
  }

  return { years: years >= 0 ? years : 0, months, days, text };
};
